import { render } from "./LanguageSelect.vue?vue&type=template&id=7d2388e5&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=7d2388e5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2388e5"]])

export default __exports__